import { gql } from '@apollo/client'

export const CREATE_OR_UPDATE_TARGET_CORRECTION_PAYMENT = gql`
  mutation createOrUpdateTargetCorrectionPayment($targetCorrectionPayment: TargetCorrectionPaymentInput!) {
    createOrUpdateTargetCorrectionPayment(targetCorrectionPayment: $targetCorrectionPayment) {
      id
      paymentDate
      status
      resultAmount
      comment
      referenceYear
      meetingId
      paymentDateValid
    }
  }
`
export const DELETE_TARGET_CORRECTION_PAYMENT = gql`
  mutation deleteTargetCorrectionPayment($targetCorrectionPaymentId: HashedId!) {
    deleteTargetCorrectionPayment(targetCorrectionPaymentId: $targetCorrectionPaymentId) {
      id
    }
  }
`
